import axios from '@/axiosConnection'
import toastr from '@/toastr'

export default {
  namespaced: true,
  state: {
    items: [],
    // Vocabulaires servis par l'API : ils vivent côté back (LocationForAccountConstant), pas
    // en double ici — une valeur ajoutée là-bas doit apparaître sans toucher au front.
    options: {
      categories: {}
    }
  },
  getters: {
    getAll: state => state.items,
    getItem: state => id => state.items.find(item => item.id == id),
    getCategoriesForSelect: state => Object.entries(state.options.categories || {})
      .map(([value, text]) => ({ value, text })),
    getCategoryLabel: state => category => (state.options.categories || {})[category] || category,
    // Suggestions d'autocomplétion à la saisie d'une ligne de frais : les actifs seuls.
    getSuggestions: state => state.items.filter(item => item.active)
  },
  mutations: {
    setOptions(state, options) {
      state.options = { ...state.options, ...options }
    }
  },
  actions: {
    /**
     * Charge les vocabulaires fermés du module (types de champ, catégories de frais).
     * Ils sont servis par l'API plutôt que recopiés ici : une valeur ajoutée côté back doit
     * apparaître sans toucher au front.
     */
    getOptions(context) {
      return axios.get('feelabel/options')
        .then(response => {
          if (response && response.data) {
            context.commit('setOptions', response.data)
          }
          return response
        })
        .catch(error => {
          toastr.error("Le chargement des options a échoué")
          return Promise.reject(error)
        })
    },
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'feelabel',
        api_data_path: 'feeLabels',
        namespace: 'fee_label'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'feelabel',
        namespace: 'fee_label',
        id: id
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'feelabel',
        namespace: 'fee_label',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'feelabel',
        namespace: 'fee_label',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'feelabel',
        namespace: 'fee_label',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/fee_label.js